<template>
  <div class="body w">
    <CBackNav v-if="isShare" title="组织单位"></CBackNav>
    <div class="offset"></div>
    <titleAndText class="explan" title="活动名称" :text="getName"></titleAndText>
    <titleAndText class="explan" title="指导单位" :text="getguidancers" v-if="getguidancers!=''"></titleAndText>
    <titleAndText class="explan" title="主办单位" :text="getorganizers" v-if="getorganizers!=''"></titleAndText>
    <titleAndText class="explan" title="承办单位" :text="getundertakers" v-if="getundertakers!=''"></titleAndText>
    <titleAndText class="explan" title="协办单位" :text="getcoOrganizers" v-if="getcoOrganizers!=''"></titleAndText>
    <titleAndText class="explan" title="支持单位" :text="getsupporters" v-if="getsupporters!=''"></titleAndText>
    <titleAndText class="explan" title="支持媒体" :text="getsupportMedias" v-if="getsupportMedias!=''"></titleAndText>
    <titleAndText class="explan" title="技术支持" :text="gettechnicians" v-if="gettechnicians!=''"></titleAndText>

<!--    <titleAndText class="explan" title="比赛时间" :text="getTime"></titleAndText>-->
<!--    <titleAndText class="explan" title="比赛地点" :text="getFinalVenue" v-if="getFinalVenue!=''"></titleAndText>-->
<!--    <titleAndText class="explan" title="参赛对象" :text="getGrade" v-if="getGrade!=''"></titleAndText>-->
<!--    <titleAndText class="explan" title="参赛学校" :text="getAddressOrSchool"  v-if="getAddressOrSchool!=''"></titleAndText>-->
    <div class="offset"></div>
  </div>
</template>

<script>
import NavBar from "../../components/common/navBar/NavBar";
import titleAndText from "./item/titleAndText";
import {utils} from "../../network/utils";
import {actUtil} from "../../js/activity/util";
import {Toast} from "vant";
import {app} from "../../network/app/app";
import CBackNav from "../../components/CBackNav";

export default {
  name: "allMainUnit",
  components:{
    NavBar,
    titleAndText,
    CBackNav
  },
  data(){
    return {
      baseInfo: null,
    }
  },
  methods:{
    backClick(){
      // Toast.success('back click');
      this.$router.back()
      console.log('back click')
    },
    getContext(arr){
      let str = ''
      for(let j = 0; j < arr.length; j++) {
        if(str!=''){
          str += '\n'
        }
        str += arr[j]
      }
      return str
    }
  },
  created() {
    console.log('参赛单位 create');
    // console.log(this.$route.params)
    this.baseInfo = this.$route.params
  },
  destroyed() {
    console.log('参赛单位 destroyed');
  },
  computed:{
    isShare(){
      if(app.getState()){
        return false
      }else{
        return true
      }
    },
    getName() {
      if(this.baseInfo==null)
        return ''

      return this.baseInfo.title
    },
    getguidancers(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.guidancers)
    },

    getorganizers(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.organizers)
    },

    getundertakers(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.undertakers)
    },

    getcoOrganizers(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.coOrganizers)
    },

    getsupporters(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.supporters)
    },

    getsupportMedias(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.supportMedias)
    },

    gettechnicians(){
      if(this.baseInfo==null){
        return ''
      }
      return this.getContext(this.baseInfo.technicians)
    },


    getTecSup(){
      let str = ''
      str += '中科嗨学（广州）科技发展有限公司'
      return str;
    },
    getCoOrg(){
      let str = ''
      if(this.baseInfo.id==6){
        str += '中国科学报广东记者站'
      }else{
        str += '中科拜尔教育科技（广州）有限公司'
      }

      return str;
    },
    getGuideOrg(){
      let str = ''
      if(this.baseInfo.id==6){
        str += '中国科学院科学传播局'
        str += '\n'
        str += '中共广东省委宣传部'
        str += '\n'
        str += '广东省教育厅'
        str += '\n'
        str += '广东省科学技术厅'
        str += '\n'
        str += '广东省科学技术协会'
        str += '\n'
        str += '共青团广东省委员会'
      }else{
        str += '中国科学院广州分院'
        str += '\n'
        str += '中共广东省委宣传部'
        str += '\n'
        str += '广东省教育厅'
        str += '\n'
        str += '广东省科学技术厅'
        str += '\n'
        str += '广东省科学技术协会'
        str += '\n'
        str += '共青团广东省委员会'
      }

      return str;
    },
    getChenBanOrg(){
      let str = ''
      if(this.baseInfo.id==6){
        str += '中国科学院广州分院科普志愿者服务团'
        str += '\n'
        str += '中科拜尔教育科技（广州）有限公司'
      }else{
        // str += '中科拜尔教育科技（广州）有限公司'
      }

      return str;
    },
    getOrganizers(){
      if(this.baseInfo==null)
        return ''

      let begin = 0
      if((this.baseInfo.id==4)
        ||(this.baseInfo.id==5)){
        begin=2
      }

      let str = ''
      let arr = this.baseInfo.organizers
      //由于重复，这里做了特殊处理
      for(let j = begin; j < arr.length; j++) {
        if(str!=''){
          str += '\n'
        }
        str += arr[j]
      }

      return str;
    },
    getTime(){
      if(this.baseInfo==null)
        return ''

      return utils.date('Y-m-d', this.baseInfo.startDate) + " 至 " + utils.date('Y-m-d', this.baseInfo.endDate)
    },
    getFinalVenue(){
      if(this.baseInfo==null)
        return ''

      return this.baseInfo.finalVenue
    },
    getGrade(){
      if(this.baseInfo==null)
        return ''

      let str = ''
      let arr = this.baseInfo.range_grade
      for(let j = 0; j < arr.length; j++) {
        if(arr[j].type==2){
          if(str!=''){
            str += '、'
          }
          str += actUtil.toGradeString(arr[j].rang)
        }
      }

      //判断增加是否是专家
      if(this.baseInfo.target&0x4){
        if(str!=''){
          str += '、'
        }
        str += '科普专家'
      }

      return str
    },
    getAddressOrSchool(){
      if(this.baseInfo==null)
        return ''

      let tmp = ''
      let str = ''
      let arrSchool = this.baseInfo.range_school
      let arrAddress = this.baseInfo.range_address

      // for(let j = 0; j < arrAddress.length; j++) {
      //   if(str!=''){
      //     str += '\n'
      //   }
      //   str += arrAddress[j].rang
      // }

      for(let j = 0; j < arrSchool.length; j++) {
        if(str!=''){
          str += '\n'
        }
        // tmp = arrSchool[j].city + arrSchool[j].district
        tmp = ''
        if(tmp==''){
          str += arrSchool[j].school
        }else{
          str += tmp+arrSchool[j].school
        }
      }
      return str
    }
  }
}
</script>

<style scoped>
.body{
  background-color: #f6f7fb;
  width: 100%;
  min-height: 100vh;
}
.title{
  display: flex;
  font-size: 45px;
  /*background-color: #00a4e2;*/
  height: 54px;
  line-height: 54px;
}
.title-item{
  flex: 1;
}
.title-item span{
  padding: 5px;
}
.back{
  /*background-color: #6ff300;*/
  height: 54px;
  width: 140px;
  background-image: url("../../assets/act001/back.png");
  background-size: 23px 40px;
  background-repeat: no-repeat;
  background-position: 40px center;
  z-index: 99;
}
.back img{
  /*margin-top: 12px;*/
  margin-left: 20px;
  width: 20px;
}
.offset{
  width: 100%;
  height: 40px;
}
.explan{
  margin-bottom: 40px;
}


.nav-bar{
  display: flex;
  padding-top: 50px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  color: #30353d;
  /*box-shadow: 0 1px 1px rgba(100,100,100,.1);*/
}
.left, .right{
  width: 140px;
  height: 54px;
  /*background-color: red;*/
}
.center{
  flex: 1;
  /*background-color: blue;*/
}
</style>